// noinspection JSUnuseCommandMapServicedGlobalSymbols

import Legend from 'ol-ext/legend/Legend'
import type Map from 'ol/Map'

export class CommandMapService {
    public vectorStyles: any
    public legend: Legend = new Legend()
    public legend2: Legend = new Legend()

    constructor(private map: Map) {
        this.vectorStyles = {}
    }

    setLegend(legend: Legend) {
        this.legend = legend
    }
}
